import { rowEdit } from './rowEdit';
import { toTree } from './toTree';

export const Table = {
	rowEdit,
	toTree
};
